module.exports = __webpack_public_path__ + "img/2.42a6e9de.png";